import React from 'react';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/system';

import { getHeaderLinkLighterColor } from 'styles/helpers/getThemeStyles';

const StyledDivider = styled(Divider)(({ theme }) => ({
  display: 'none',
  background: getHeaderLinkLighterColor(theme),
  width: 1,
  height: 39,
  margin: '0 8px 0 8px',
  [theme.breakpoints.up('md')]: {
    display: 'block'
  }
}));

function AppBarDivider() {
  return <StyledDivider orientation="vertical" />;
}

export default AppBarDivider;
